import { mapState } from 'vuex'

export default {
    data() {
        return {
            model: {},
        }
    },

    computed: {
        ...mapState({
            globalTexts: (state) => state.jsonloader.data['global.json'] || null,
        }),

        spouses() {
            const model = this.model?.user || this.model
            const spouse = model.wedding_details?.other_firstname ? ' & ' + model.wedding_details.other_firstname : ''
            return model.firstname + spouse
        },
    },

    methods: {
        getPlaceholder(text) {
            return text.replace('%spouses%', this.spouses)
        },
    },
}
